var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-image-viewer',{attrs:{"zIndex":999999,"on-close":_vm.closeViewer,"url-list":_vm.urlList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }